import { useLocation } from 'react-router-dom';
import './sessionComplete.css';

// Where the presenter session sends the customer once the call is over — either
// after they submit feedback or after they dismiss the feedback card. It is a
// standalone, auth-free dead end on purpose: the socket, the mic and the slide
// deck are all gone by the time this renders, so there is nothing to come back to.
export type SessionCompleteState = {
  sessionTitle?: string;
  feedbackSubmitted?: boolean;
  actionUrl?: string;
  actionLabel?: string;
};

export default function SessionComplete() {
  const location = useLocation();
  const state = (location.state as SessionCompleteState | null) ?? {};
  const { sessionTitle, feedbackSubmitted, actionUrl, actionLabel } = state;

  // No "close this tab" button on purpose: window.close() is refused for tabs the
  // page didn't open itself, so it would be a dead control most of the time. The
  // instruction below says the same thing without promising an action we can't do.
  return (
    <main className="psc-page">
      <div className="psc-glow" aria-hidden="true" />

      <section className="psc-card">
        <div className="psc-badge" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2.6} strokeLinecap="round" strokeLinejoin="round">
            <path d="m4.5 12.5 5 5 10-11" />
          </svg>
        </div>

        <h1>Thank you for your time</h1>
        <p className="psc-lead">
          {sessionTitle ? (
            <>
              Your session on <strong>{sessionTitle}</strong> has ended.
            </>
          ) : (
            <>Your session has ended.</>
          )}{' '}
          We hope it was useful.
        </p>

        {feedbackSubmitted && (
          <div className="psc-note" role="status">
            Your feedback has been recorded — it genuinely helps us improve.
          </div>
        )}

        {actionUrl && (
          <a className="psc-cta" href={actionUrl} target="_blank" rel="noreferrer">
            {actionLabel || 'Continue'}
          </a>
        )}

        <div className="psc-divider" aria-hidden="true" />

        <p className="psc-close-hint">Nothing else is needed from you — you can close this tab whenever you&apos;re ready.</p>
      </section>

      <footer className="psc-footer">
        <span className="psc-mark">NUWAY</span>
        <span>AI presenter</span>
      </footer>
    </main>
  );
}
